import axios from 'axios';

const baseURL = 'api/Pregunta';

async function getActual(usuario, idEje) {
    const { data } = await axios.get(baseURL + "/actual?idUsuario=" + usuario.id + "&idEje=" + idEje + "&language=" + usuario.language,
    {
        headers: {
            'token': usuario.token
        }
    }
    );

    return data;
}

export default { getActual };